import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiUrl } from '../custom-services/api-url/api-url';
import { ApiService } from '../custom-services/ApiService';


@Component({
    selector: 'app-a-challan-payment-check',
    templateUrl: './a-challan-payment-check.component.html',
    styleUrls: ['./a-challan-payment-check.component.css'],
    standalone: false
})
export class AChallanPaymentCheckComponent implements OnInit {
  isSuccess: boolean = false;
  transactionId: any;
  userTIN: any;
  isApiCall:boolean=false;
  redirect:boolean=false
  currentAssessmentYear: string;
  msg: string;
  baseUrl:string = environment.taxpayer_base_url;

  apiService: ApiService;
  apiUrl: ApiUrl;
  public challanResponse: any;

  constructor(
    private activeRoutes: ActivatedRoute,
    private router: Router,
    apiService: ApiService,
    apiUrl: ApiUrl,
  ) {
    this.activeRoutes.queryParams.subscribe(params => {
      this.transactionId = params['transaction_id'];
    });
    this.apiService = apiService;
    this.apiUrl = apiUrl;
  }

  ngOnInit(): void {
    this.apiUrl.getUrl().subscribe(res => {
    });

    this.userTIN = localStorage.getItem("tin");
    this.paymentCheck();
  }

  paymentCheck() {
    this.msg = "Syncing payment, please wait...";
    this.isSuccess = false;
    this.isApiCall = false;

    setTimeout(() => {
      const requestJson = { transactionId: this.transactionId };

      this.apiService.post(
        environment.taxpayer_base_url + '/filingservice/v3/api/payment/payment-callback',
        requestJson
      ).subscribe({
        next: (result: any) => {
          this.isApiCall = true;

          if (JSON.stringify(result.replyMessage) !== '{}') {
            this.isSuccess = true;
            this.msg = result.replyMessage.message;
            this.challanResponse = result.replyMessage.challanResponse;
          }
        },
        error: (err: any) => {
          this.isApiCall = true;
          this.msg = err?.error?.errorMessage;
          this.isSuccess = false;
        }
      });
    }, 1000);
  }


  redirectTaxAndPayment(){
    this.redirect=true;
    this.router.navigate(["/user-panel/tax-and-payment"]);
    this.msg="Redirecting Tax & Payment Page";
  }

}
